export default __webpack_public_path__ + "content/aa859c0d08b8193d6586665343356098.woff";